(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('search-load-more')) {
    customElements.define('search-load-more', class SearchLoadMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-load-more-label]');
        if (!this.label) {
          this.label = document.createElement('span');
          this.label.dataset.loadMoreLabel = '';
          this.label.textContent = 'Load more';
          this.button.replaceChildren(this.label);
        }
        this.status = this.querySelector('[role="status"]');
        this.button.hidden = false;
        this.onClick = this.onClick || this.loadMore.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.button?.removeEventListener('click', this.onClick);
      }

      async loadMore() {
        const grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
        if (this.loading || !this.dataset.nextUrl || !grid || grid.classList.contains('loading')) return;

        this.loading = true;
        this.button.disabled = true;
        this.label.textContent = 'Loading…';
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        this.controller = new AbortController();
        const currentUrl = window.location.href;

        try {
          const url = new URL(this.dataset.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString(), { signal: this.controller.signal });
          if (!response.ok) throw new Error('Search results could not be loaded');

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = html.querySelector('#product-grid');
          if (!nextGrid || !nextGrid.children.length) throw new Error('Search results were empty');
          if (!this.isConnected || window.location.href !== currentUrl || grid.classList.contains('loading')) return;

          const seenFamilies = new Set(Array.from(grid.querySelectorAll('[data-search-family]'), card => card.dataset.searchFamily));
          const cards = Array.from(nextGrid.children).filter(card => {
            const family = card.dataset.searchFamily;
            if (!family) return true;
            if (seenFamilies.has(family)) return false;
            seenFamilies.add(family);
            return true;
          });
          const nextControl = html.querySelector('search-load-more');
          const scrollX = window.scrollX;
          const scrollY = window.scrollY;
          const buttonHadFocus = document.activeElement === this.button;
          grid.append(...cards);
          this.dataset.nextUrl = nextControl?.dataset.nextUrl || '';
          this.button.hidden = !this.dataset.nextUrl;
          this.status.textContent = `${grid.children.length} of ${this.dataset.total} results shown.${this.dataset.nextUrl ? '' : ' No more results.'}`;
          if (buttonHadFocus) cards[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
          window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) {
            this.status.textContent = 'Couldn’t load more products. Please try again.';
          }
        } finally {
          this.loading = false;
          this.button.disabled = false;
          this.label.textContent = 'Load more';
          this.removeAttribute('aria-busy');
        }
      }
    });
  }

  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sk-popup]';

    const readUntil = (key) => {
      try {
        return Number(window.localStorage.getItem(key) || 0);
      } catch (error) {
        return 0;
      }
    };

    const writeUntil = (key, until) => {
      try {
        window.localStorage.setItem(key, String(until));
      } catch (error) {
        return;
      }
    };

    const initialize = (dialog) => {
      if (dialog.dataset.skPopupReady === 'true') return;
      dialog.dataset.skPopupReady = 'true';

      const closeButton = dialog.querySelector('[data-sk-popup-close]');
      const emailInput = dialog.querySelector('input[type="email"]');
      const success = dialog.querySelector('.sk-popup__success');
      const errors = dialog.querySelector('.sk-popup__errors');
      const delaySeconds = Math.max(3, Number(dialog.dataset.delaySeconds || 10));
      const dismissDays = Math.max(1, Number(dialog.dataset.dismissDays || 14));
      const storageKey = 'skool-krafts-newsletter-popup';
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      let returnFocus = null;
      let delayReady = false;
      let intentReady = false;
      let delayTimer = null;
      let fallbackTimer = null;

      const cleanup = () => {
        if (delayTimer) window.clearTimeout(delayTimer);
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseout', onExitIntent);
      };

      const open = () => {
        if (dialog.open) return;
        returnFocus = document.activeElement;
        dialog.showModal();
        window.setTimeout(() => {
          const focusTarget = success || emailInput || closeButton;
          if (focusTarget) focusTarget.focus();
        }, 40);
        cleanup();
      };

      const dismiss = () => {
        writeUntil(storageKey, Date.now() + dismissDays * 86400000);
        if (dialog.open) dialog.close();
        if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
        cleanup();
      };

      const maybeOpen = () => {
        if (delayReady && intentReady && document.visibilityState === 'visible') open();
      };

      const onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 300 || window.scrollY / scrollable >= 0.22) {
          intentReady = true;
          window.removeEventListener('scroll', onScroll);
          maybeOpen();
        }
      };

      const onExitIntent = (event) => {
        if (event.clientY <= 6 && !event.relatedTarget) {
          intentReady = true;
          document.removeEventListener('mouseout', onExitIntent);
          maybeOpen();
        }
      };

      closeButton?.addEventListener('click', dismiss);

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        dismiss();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dismiss();
      });

      if (success) {
        writeUntil(storageKey, Date.now() + 31536000000);
        window.setTimeout(open, 120);
        return;
      }

      if (errors) {
        window.setTimeout(open, 120);
        return;
      }

      if (window.Shopify && window.Shopify.designMode) {
        window.setTimeout(open, 180);
        return;
      }

      if (isMobile && dialog.dataset.showMobile !== 'true') return;
      if (readUntil(storageKey) > Date.now()) return;

      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      intentReady = scrollable <= 300;

      delayTimer = window.setTimeout(() => {
        delayReady = true;
        maybeOpen();
      }, delaySeconds * 1000);

      fallbackTimer = window.setTimeout(() => {
        delayReady = true;
        intentReady = true;
        maybeOpen();
      }, (delaySeconds + 14) * 1000);

      window.addEventListener('scroll', onScroll, { passive: true });
      if (!isMobile) document.addEventListener('mouseout', onExitIntent);
    };

    const boot = (root) => {
      root.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', (event) => boot(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const dialog = event.target.querySelector(selector);
      if (dialog && !dialog.open) dialog.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
